<footer>
  Copyright © 1999-2024 Rockton Software, Inc. 
  All Rights Reserved.
</footer>
